import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=444acd03"
import script from "./Words.vue?vue&type=script&lang=js"
export * from "./Words.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports